/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CableTrayComponent } from './cable-tray.component';
import { SysqueOptionsLineModule } from '../../../../../../../../../shared/ui/src/lib/components/sysque-options-line';
import { CableTraySpoolTagModule } from './tag-options/spool-tag';
import { CableTraySizeTagModule } from './tag-options/size-tag';
import { CableTrayItemNumberTagModule } from './tag-options/item-number-tag';
import { CableTrayElevationTagModule } from './tag-options/elevation-tag';

@NgModule({
  declarations: [CableTrayComponent],
  imports: [
    CommonModule,
    SysqueOptionsLineModule,
    CableTraySpoolTagModule,
    CableTraySizeTagModule,
    CableTrayItemNumberTagModule,
    CableTrayElevationTagModule
  ],
  exports: [CableTrayComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CableTrayModule {}
